import { GiLanternFlame, GiPumpkinLantern } from "react-icons/gi";
import { QuestModelType } from "../context/game/types/questModelType";
import { FaCarrot, FaEgg, FaFeather, FaGift, FaTree } from "react-icons/fa6";


export const AllQuestModelConst:QuestModelType[]= [
    {
        id: "d82d5fd7-7ef8-49fb-90b9-9ee4288edc06",
        type: "RANDOM",
        element: [
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Tu ne devineras jamais ce qui vient d'arriver ! Un esprit farceur a dispersé les œufs des Gooblies partout dans le royaume ! Si on ne les retrouve pas vite, ces petites créatures espiègles pourraient disparaître à jamais. Suis le chemin pour les retrouver et t'en occuper.",
                    en: "You'll never guess what just happened! A mischievous spirit scattered the Gooblies' eggs all over the kingdom! If we don't find them soon, these playful little creatures might disappear forever. Follow the path to find and take care of them.",
                    de: "Du wirst nie erraten, was gerade passiert ist! Ein schelmischer Geist hat die Gooblie-Eier überall im Königreich verstreut! Wenn wir sie nicht bald finden, könnten diese kleinen verspielten Kreaturen für immer verschwinden. Folge dem Pfad, um sie zu finden und dich um sie zu kümmern.",
                    nl: "Je raadt nooit wat er net is gebeurd! Een ondeugende geest heeft de eieren van de Gooblies door het hele koninkrijk verspreid! Als we ze niet snel vinden, kunnen deze speelse kleine wezens voor altijd verdwijnen. Volg het pad om ze te vinden en voor ze te zorgen."
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Sois très attentif, observe bien les détails, sur le sol, dans les arbres, dans les buissons, les Gooblies sont partout, et ils adorent se cacher. Si tu es attentif, tu pourras voir leurs traces et entrer dans leur univers.",
                    en: "Be very attentive, look closely at the details on the ground, in the trees, and in the bushes. The Gooblies are everywhere, and they love to hide. If you pay close attention, you might see their tracks and enter their world.",
                    de: "Sei sehr aufmerksam, schau genau hin, auf den Boden, in die Bäume und in die Büsche. Die Gooblies sind überall, und sie verstecken sich gerne. Wenn du genau hinschaust, kannst du ihre Spuren sehen und in ihre Welt eintreten.",
                    nl: "Wees heel oplettend, kijk goed naar de details op de grond, in de bomen en in de struiken. De Gooblies zijn overal, en ze houden ervan om zich te verstoppen. Als je goed oplet, zie je misschien hun sporen en betreed je hun wereld."
                }
            },
            {
                items: "egg",
                position: null,
                soundBefore: "laugh01",
                messageBefore: {
                    fr: "Oh ! Tu as entendu ce rire ? Il doit y avoir des œufs rieurs cachés dans le coin ! Saute trois fois sur place pour les faire apparaître.",
                    en: "Oh! Did you hear that laugh? There must be laughing eggs hidden nearby! Jump three times to make them appear.",
                    de: "Oh! Hast du dieses Lachen gehört? Hier in der Nähe müssen lachende Eier versteckt sein! Spring dreimal, um sie erscheinen zu lassen.",
                    nl: "Oh! Heb je dat gelach gehoord? Er moeten lachende eieren verstopt zijn hier in de buurt! Spring drie keer om ze te laten verschijnen."
                },
                messageAfter: null,
                unblockItem: true,
                icon: <FaEgg  style={{width:"32", height:"32"}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: "grass01",
                messageBefore: null,
                messageAfter: {
                    fr: "Chuuut, tu as entendu ce bruit ? C'est probablement un Gooblie qui se cache dans les buissons. Si tu es attentif, tu pourras peut-être le voir.",
                    en: "Shhh, did you hear that sound? It's probably a Gooblie hiding in the bushes. If you're careful, you might catch a glimpse of it.",
                    de: "Pssst, hast du dieses Geräusch gehört? Es ist wahrscheinlich ein Gooblie, das sich in den Büschen versteckt. Wenn du aufmerksam bist, kannst du es vielleicht sehen.",
                    nl: "Sssst, heb je dat geluid gehoord? Het is waarschijnlijk een Gooblie die zich in de struiken verstopt. Als je goed kijkt, zie je hem misschien."
                }
            },
            {
                items: "egg",
                position: null,
                soundBefore: "magic01",
                messageBefore: {
                    fr: "Hey, je crois que c'est le bruit d'un œuf magique, il doit être caché dans le coin !",
                    en: "Hey, I think that's the sound of a magic egg. It must be hidden around here!",
                    de: "Hey, ich glaube, das ist das Geräusch eines magischen Eies. Es muss hier in der Nähe versteckt sein!",
                    nl: "Hey, ik denk dat dat het geluid van een magisch ei is. Het moet hier ergens verstopt zijn!"
                },
                messageAfter: null,
                unblockItem: true,
                icon: <FaEgg  style={{width:"32", height:"32"}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Tiens, ce sentier me semble étrange… les Gooblies laissent des traces invisibles. Est-ce que tu peux les voir toi aussi ? Si tu les suis, peut-être que tu découvriras quelque chose de fascinant.",
                    en: "Hmm, this path seems strange… Gooblies leave invisible traces. Can you see them too? If you follow them, you might discover something fascinating.",
                    de: "Hm, dieser Pfad sieht seltsam aus… Gooblies hinterlassen unsichtbare Spuren. Kannst du sie auch sehen? Wenn du ihnen folgst, entdeckst du vielleicht etwas Faszinierendes.",
                    nl: "Hmm, dit pad lijkt vreemd… Gooblies laten onzichtbare sporen achter. Zie jij ze ook? Als je ze volgt, ontdek je misschien iets fascinerends."
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: "whoosh01",
                messageBefore: null,
                messageAfter: {
                    fr: "Oula, tu as entendu ce bruit ? il y a un Gooblie farceur dans le coin ! Je sens qu'on se rapproche, avance encore un peu et tu vas le capturer !",
                    en: "Whoa, did you hear that sound? There's a prankster Gooblie nearby! I can feel it getting closer, just a bit further and you'll capture it!",
                    de: "Wow, hast du dieses Geräusch gehört? Hier in der Nähe ist ein Scherzkeks-Gooblie! Ich spüre, dass wir uns nähern, geh ein Stück weiter und du wirst es fangen!",
                    nl: "Wauw, heb je dat geluid gehoord? Er is een ondeugende Gooblie in de buurt! Ik voel dat we dichterbij komen, nog een beetje verder en je vangt hem!"
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Hey ! Tu te débrouilles incroyablement bien ! Tous les aventuriers n'arrivent pas à se rendre aussi loin. Continue d'explorer, je suis sûr que de grandes découvertes t'attendent encore. N'oublie pas, les créatures rares sont souvent celles qui se cachent le mieux.",
                    en: "Hey! You're doing incredibly well! Not all adventurers make it this far. Keep exploring, I'm sure great discoveries still await you. Remember, rare creatures are often the ones that hide the best.",
                    de: "Hey! Du machst dich unglaublich gut! Nicht alle Abenteurer schaffen es so weit. Erforsche weiter, ich bin sicher, dass dich noch großartige Entdeckungen erwarten. Denk daran, seltene Kreaturen verstecken sich oft am besten.",
                    nl: "Hey! Je doet het ongelooflijk goed! Niet alle avonturiers komen zo ver. Blijf verkennen, ik weet zeker dat er nog grote ontdekkingen op je wachten. Vergeet niet, zeldzame wezens verstoppen zich vaak het best."
                }
            },
            {
                items: "egg",
                position: null,
                soundBefore: "laugh01",
                messageBefore: {
                    fr: "Tu as entendu ce rire ? Il doit y avoir des œufs rieurs cachés dans le coin ! Fais un tour sur toi-même pour les faire apparaître.",
                    en: "Did you hear that laugh? There must be laughing eggs hidden nearby! Spin around to make them appear.",
                    de: "Hast du dieses Lachen gehört? Hier in der Nähe müssen lachende Eier versteckt sein! Dreh dich um dich selbst, um sie erscheinen zu lassen.",
                    nl: "Heb je dat gelach gehoord? Er moeten lachende eieren verstopt zijn in de buurt! Draai om je as om ze te laten verschijnen."
                },
                messageAfter: null,
                unblockItem: true,
                icon: <FaEgg  style={{width:"32", height:"32"}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Tu savais que la passion des Gooblies c'est de se cacher ? Ils adorent se cacher dans les endroits les plus inattendus. Si tu es attentif, tu pourras les voir. Mais attention, ils sont très malins, et ils adorent jouer des tours.",
                    en: "Did you know the Gooblies' passion is hiding? They love to hide in the most unexpected places. If you're careful, you might see them. But be careful, they're very sneaky and love playing tricks.",
                    de: "Wusstest du, dass die Leidenschaft der Gooblies es ist, sich zu verstecken? Sie lieben es, sich an den unerwartetsten Orten zu verstecken. Wenn du gut aufpasst, kannst du sie sehen. Aber Vorsicht, sie sind sehr schlau und lieben es, Streiche zu spielen.",
                    nl: "Wist je dat de Gooblies dol zijn op verstoppen? Ze houden ervan om zich op de meest onverwachte plekken te verstoppen. Als je goed oplet, kun je ze zien. Maar wees voorzichtig, ze zijn erg sluw en houden van grapjes maken."
                }
            },
            {
                items: "egg",
                position: null,
                soundBefore: "magic01",
                messageBefore: {
                    fr: "Hey je crois qu'on est pas loin d'un œuf magique de nouveau, il doit être caché dans le coin ! Avance lentement et regarde bien autour de toi.",
                    en: "Hey, I think we're close to another magic egg. It must be hidden around here! Walk slowly and look around carefully.",
                    de: "Hey, ich glaube, wir sind wieder in der Nähe eines magischen Eies. Es muss hier in der Nähe versteckt sein! Geh langsam und schau dich genau um.",
                    nl: "Hey, ik denk dat we dicht bij een ander magisch ei zijn. Het moet hier ergens verstopt zijn! Loop langzaam en kijk goed om je heen."
                },
                messageAfter: null,
                unblockItem: true,
                icon: <FaEgg style={{width:"32", height:"32"}}/>
            }
        ],
        artifact:{
            id: "1e2be128-90ab-4ca7-a005-01bfb265417e",
            name: "Magic",
            url: "/images/artifact_magic.jpeg"
        },
        name: {
            fr: "La Quête des œufs magiques",
            en: "The Quest for the Magic Eggs",
            de: "Die Suche nach den magischen Eiern",
            nl: "De zoektocht naar de magische eieren"
        },
        messageUnblocked:{
            fr: "Bravo, tu as réussi à retrouver tous les œufs magiques ! Grâce à toi, ils pourront continuer à vivre en paix et en sécurité.",
            en: "Congratulations, you've managed to find all the magic eggs! Thanks to you, they'll be able to continue living in peace and safety.",
            de: "Herzlichen Glückwunsch, du hast es geschafft, alle magischen Eier zu finden! Dank dir können sie weiterhin in Frieden und Sicherheit leben.",
            nl: "Gefeliciteerd, je hebt alle magische eieren gevonden! Dankzij jou kunnen ze blijven leven in vrede en veiligheid."
        },
        price: 250,
        shortTitle: {
            fr: "Retrouve les oeufs de Gooblies",
            en: "Find the Gooblie eggs",
            de: "Finde die Go",
            nl: "Vind de Go"
        }
    },
    {
        id: "cf14c2d0-1e28-463d-ba67-c842173f3508",
        type: "RANDOM",
        element: [
            {
                items: "none",
                position: null,
                soundBefore: "halloween01",
                messageBefore: null,
                messageAfter: {
                    fr: "Hey, devine quoi ? Des lanternes magiques sont apparues un peu partout, et elles sont cruciales pour que les Gooblies puissent fêter Halloween. Mais attention… les sorcières ne sont jamais loin, prêtes à éteindre la fête ! Seul un vrai héros peut les retrouver avant qu'il ne soit trop tard. Mais ce n'est pas fini ! Pour débloquer leur magie, tu devras aussi répondre à des quiz sur l'environnement. Si tu réussis, un artefact d'Halloween apparaîtra. Alors, prêt à illuminer la nuit et à devenir le héros d'Halloween ?",
                    en: "Hey, guess what? Magical lanterns have appeared all around, and they are crucial for the Gooblies to celebrate Halloween. But beware... witches are never far, ready to extinguish the party! Only a true hero can find them before it's too late. But that's not all! To unlock their magic, you'll also need to answer quizzes about the environment. If you succeed, a Halloween artifact will appear. So, ready to light up the night and become the Halloween hero?",
                    de: "Hey, rate mal! Magische Laternen sind überall aufgetaucht, und sie sind entscheidend, damit die Gooblies Halloween feiern können. Aber Vorsicht… Hexen sind nie weit weg, bereit, die Feier zu beenden! Nur ein echter Held kann sie finden, bevor es zu spät ist. Aber das ist noch nicht alles! Um ihre Magie freizusetzen, musst du auch Fragen zur Umgebung beantworten. Wenn du erfolgreich bist, wird ein Halloween-Artefakt erscheinen. Also, bereit, die Nacht zu erleuchten und der Halloween-Held zu werden?",
                    nl: "Hé, raad eens? Magische lantaarns zijn overal verschenen, en ze zijn cruciaal voor de Gooblies om Halloween te vieren. Maar pas op... heksen zijn nooit ver weg, klaar om het feest te stoppen! Alleen een echte held kan ze vinden voordat het te laat is. Maar dat is nog niet alles! Om hun magie te ontgrendelen, moet je ook vragen over de omgeving beantwoorden. Als je slaagt, zal een Halloween-artifact verschijnen. Klaar om de nacht te verlichten en de Halloween-held te worden?"
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Tu sais, ces lanternes ne sont pas juste jolies à regarder… Elles renferment une magie ancienne, indispensable pour Halloween ! Chaque année, les Gooblies les allument pour illuminer la nuit et éloigner les ombres inquiétantes. Sans elles, Halloween perdrait toute sa magie, et les créatures enchantées ne pourraient pas célébrer comme il se doit. Chaque lanterne porte en elle une petite étincelle d'un sortilège oublié…",
                    en: "You know, these lanterns aren't just pretty to look at... They hold ancient magic, essential for Halloween! Every year, the Gooblies light them to brighten the night and ward off eerie shadows. Without them, Halloween would lose all its magic, and enchanted creatures wouldn't be able to celebrate properly. Each lantern carries a small spark of a forgotten spell...",
                    de: "Weißt du, diese Laternen sind nicht nur schön anzusehen… Sie enthalten uralte Magie, die für Halloween unerlässlich ist! Jedes Jahr zünden die Gooblies sie an, um die Nacht zu erhellen und unheimliche Schatten zu vertreiben. Ohne sie würde Halloween seine ganze Magie verlieren, und die verzauberten Kreaturen könnten nicht richtig feiern. Jede Laterne trägt einen kleinen Funken eines vergessenen Zaubers in sich...",
                    nl: "Weet je, deze lantaarns zijn niet alleen mooi om naar te kijken... Ze bevatten oude magie, essentieel voor Halloween! Elk jaar steken de Gooblies ze aan om de nacht te verlichten en angstaanjagende schaduwen weg te jagen. Zonder hen zou Halloween al zijn magie verliezen, en betoverde wezens zouden niet goed kunnen vieren. Elke lantaarn draagt een klein vonkje van een vergeten spreuk..."
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: "witch01",
                messageBefore: null,
                messageAfter: {
                    fr: "Chuuut, tu as entendu ce bruit ? Les sorcières ne sont pas loin, retrouve les lanternes avant elles ! Mais reste attentif, elles adorent se cacher dans les endroits les plus sombres.",
                    en: "Shhh, did you hear that sound? The witches aren't far, find the lanterns before they do! But stay alert, they love hiding in the darkest places.",
                    de: "Pssst, hast du das Geräusch gehört? Die Hexen sind nicht weit weg, finde die Laternen, bevor sie es tun! Aber sei aufmerksam, sie verstecken sich gerne in den dunkelsten Ecken.",
                    nl: "Sssst, hoorde je dat geluid? De heksen zijn niet ver weg, vind de lantaarns voordat zij dat doen! Maar blijf alert, ze houden ervan om zich op de donkerste plekken te verstoppen."
                }
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Lanterne",
                        en: "Lantern",
                        de: "Laterne",
                        nl: "Lantaarn"
                    },
                    url: "/images/lantern01.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Bravo, tu as trouvé une lanterne ! Je savais que tu étais fait pour cette mission !",
                    en: "Well done, you've found a lantern! I knew you were perfect for this mission!",
                    de: "Gut gemacht, du hast eine Laterne gefunden! Ich wusste, dass du perfekt für diese Mission bist!",
                    nl: "Goed gedaan, je hebt een lantaarn gevonden! Ik wist dat je perfect was voor deze missie!"
                },
                unblockItem: true,
                icon: <GiLanternFlame style={{width:'32', height:'32'}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: "whoosh01",
                messageBefore: null,
                messageAfter: {
                    fr: "Oh ! Tu as entendu ? Une sorcière est vraiment tout près ! Il faut vite retrouver les lanternes avant qu'elle ne les éteigne !",
                    en: "Oh! Did you hear that? A witch is really close by! We need to find the lanterns quickly before she extinguishes them!",
                    de: "Oh! Hast du das gehört? Eine Hexe ist ganz in der Nähe! Wir müssen schnell die Laternen finden, bevor sie sie löscht!",
                    nl: "Oh! Heb je dat gehoord? Een heks is heel dichtbij! We moeten snel de lantaarns vinden voordat ze ze uitdooft!"
                }
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Lanterne",
                        en: "Lantern",
                        de: "Laterne",
                        nl: "Lantaarn"
                    },
                    url: "/images/lantern02.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Super, tu as trouvé une autre lanterne ! Tu es vraiment un héros !",
                    en: "Great, you've found another lantern! You're truly a hero!",
                    de: "Super, du hast eine weitere Laterne gefunden! Du bist wirklich ein Held!",
                    nl: "Geweldig, je hebt een andere lantaarn gevonden! Je bent echt een held!"
                },
                unblockItem: true,
                icon: <GiLanternFlame style={{width:'32', height:'32'}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Oh, tu n'imagines même pas à quel point la fête sera magique une fois que toutes les lanternes seront allumées ! Les Gooblies attendent ce moment avec impatience chaque année ! Quand les lanternes brillent de leurs lumières enchantées, tout devient plus beau : la nuit s’illumine, des éclats de magie flottent dans l'air, et les Gooblies dansent autour comme des fous de joie ! C'est vraiment leur moment préféré ! Et grâce à toi, tout ça sera possible.",
                    en: "Oh, you can't even imagine how magical the party will be once all the lanterns are lit! The Gooblies wait for this moment eagerly every year! When the lanterns shine with their enchanted lights, everything becomes more beautiful: the night lights up, sparks of magic float in the air, and the Gooblies dance around like crazy with joy! It's truly their favorite moment! And thanks to you, all of this will be possible.",
                    de: "Oh, du kannst dir nicht vorstellen, wie magisch die Feier wird, wenn alle Laternen angezündet sind! Die Gooblies warten jedes Jahr sehnsüchtig auf diesen Moment! Wenn die Laternen mit ihrem verzauberten Licht leuchten, wird alles schöner: Die Nacht erhellt sich, Funken von Magie schweben in der Luft, und die Gooblies tanzen vor Freude wie verrückt herum! Das ist wirklich ihr Lieblingsmoment! Und dank dir wird das alles möglich sein.",
                    nl: "Oh, je kunt je niet voorstellen hoe magisch het feest zal zijn als alle lantaarns aangestoken zijn! De Gooblies wachten elk jaar vol ongeduld op dit moment! Als de lantaarns stralen met hun betoverde licht, wordt alles mooier: de nacht verlicht, magie zweeft in de lucht, en de Gooblies dansen rond als gekken van vreugde! Het is echt hun favoriete moment! En dankzij jou zal dit allemaal mogelijk zijn."
                }
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Lanterne",
                        en: "Lantern",
                        de: "Laterne",
                        nl: "Lantaarn"
                    },
                    url: "/images/lantern03.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Félicitations, tu as trouvé une autre Lanterne ! On va bientôt pouvoir illuminer la nuit grâce à toi !",
                    en: "Congratulations, you've found another Lantern! Soon, we'll be able to light up the night thanks to you!",
                    de: "Herzlichen Glückwunsch, du hast eine weitere Laterne gefunden! Bald werden wir die Nacht dank dir erleuchten können!",
                    nl: "Gefeliciteerd, je hebt weer een lantaarn gevonden! Binnenkort kunnen we de nacht verlichten, dankzij jou!"
                },
                unblockItem: true,
                icon: <GiLanternFlame style={{width:'32', height:'32'}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: "witch01",
                messageBefore: null,
                messageAfter: {
                    fr: "Ces satanées sorcières sont vraiment partout ! Il faut vite retrouver les lanternes avant qu'elles ne les éteignent ! Et surtout reste prudent, elles sont très malines.",
                    en: "Those darn witches are everywhere! We need to find the lanterns quickly before they extinguish them! And be careful, they're very cunning.",
                    de: "Diese verdammten Hexen sind wirklich überall! Wir müssen schnell die Laternen finden, bevor sie sie auslöschen! Und sei vorsichtig, sie sind sehr schlau.",
                    nl: "Die vervelende heksen zijn overal! We moeten snel de lantaarns vinden voordat ze ze uitdoven! En wees voorzichtig, ze zijn erg sluw."
                }
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Lanterne",
                        en: "Lantern",
                        de: "Laterne",
                        nl: "Lantaarn"
                    },
                    url: "/images/lantern04.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Félicitations, tu as trouvé une autre Lanterne !",
                    en: "Congratulations, you've found another Lantern!",
                    de: "Herzlichen Glückwunsch, du hast eine weitere Laterne gefunden!",
                    nl: "Gefeliciteerd, je hebt weer een lantaarn gevonden!"
                },
                unblockItem: true,
                icon: <GiLanternFlame style={{width:'32', height:'32'}}/>
            }
        ],
        name: {
            fr: "La Quête d'Halloween",
            en: "The Halloween Quest",
            de: "Die Halloween-Quest",
            nl: "De Halloween-queeste"
        },
        artifact:{
            id: "f73344c1-916b-420e-81da-5eb5a63bb321",
            name: "Halloween",
            url: "/images/artifact_haloween.jpeg"
        },
        messageUnblocked:{
            fr: "Bravo, tu as réussi à retrouver toutes les lanternes ! Tu as illuminé la nuit et sauvé Halloween !",
            en: "Congratulations, you've found all the lanterns! You've lit up the night and saved Halloween!",
            de: "Herzlichen Glückwunsch, du hast alle Laternen gefunden! Du hast die Nacht erhellt und Halloween gerettet!",
            nl: "Gefeliciteerd, je hebt alle lantaarns gevonden! Je hebt de nacht verlicht en Halloween gered!"
        },
        background: "#ff7b12f0!important",
        color: "black",
        icon: <GiPumpkinLantern style={{marginLeft:2}}/>,
        price: 250,
        private: true,
        shortTitle: {
            fr: "Retrouve les lanternes",
            en: "Find the lanterns",
            nl: "Vind de lantaarns",
            de: "Finde die Laternen"
        }
    },
    {
        id: "48408e7f-b447-4839-a8ae-7395295cbb88",
        type : "RANDOM",
        dependOn: "feather",
        element : [
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Hey, tu ne devineras jamais ce qui est arrivé ! Des œufs de Gooblies volants ont été emportés par un vent mystérieux et se sont dispersés un peu partout. Les Gooblies comptent sur toi pour les retrouver ! Mais attention, ils sont très capricieux et aiment se cacher dans des endroits surprenants. Seras-tu capable de les retrouver tous ?",
                    en: "Hey, guess what? Flying Gooblie eggs have been scattered all around by a mysterious wind! The Gooblies are counting on you to find them! But beware, these eggs are tricky and love hiding in surprising spots. Are you up for the challenge?",
                    de: "Hey, rate mal! Fliegende Gooblie-Eier wurden von einem mysteriösen Wind überall verstreut! Die Gooblies zählen auf dich, um sie zu finden! Aber Vorsicht, diese Eier sind knifflig und verstecken sich gerne an überraschenden Orten. Bist du bereit für die Herausforderung?",
                    nl: "Hé, raad eens? Vliegende Gooblie-eieren zijn overal verspreid door een mysterieuze wind! De Gooblies rekenen op jou om ze terug te vinden! Maar pas op, deze eieren houden ervan om zich op verrassende plekken te verstoppen. Klaar voor de uitdaging?"
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Regarde là-haut, au-delà des nuages, c'est là que les Gooblies volants se cachent. On raconte que ces Gooblies gardent aussi les clés des vents magiques, ces courants qui transportent la magie à travers le monde. Sans eux, le royaume serait bien moins mystérieux et animé. C’est pour ça qu’il faut prendre soin de ces petits œufs, car ils portent en eux l’avenir des cieux !",
                    en: "Look up there, beyond the clouds, that’s where the flying Gooblies hide. It is said that these Gooblies hold the keys to the magical winds, the currents that carry magic across the world. Without them, the realm would be far less mysterious and lively. That’s why these little eggs are so important; they carry the future of the skies!",
                    de: "Schau dort oben, über den Wolken, dort verstecken sich die fliegenden Gooblies. Es heißt, dass diese Gooblies die Schlüssel zu den magischen Winden bewachen, den Strömungen, die die Magie in der Welt verbreiten. Ohne sie wäre das Reich viel weniger geheimnisvoll und lebendig. Deshalb ist es wichtig, auf diese kleinen Eier aufzupassen, denn sie tragen die Zukunft des Himmels in sich!",
                    nl: "Kijk daarboven, voorbij de wolken, daar verbergen de vliegende Gooblies zich. Er wordt gezegd dat deze Gooblies de sleutels tot de magische winden bewaren, de stromingen die magie door de wereld dragen. Zonder hen zou het rijk veel minder mysterieus en levendig zijn. Daarom zijn deze kleine eieren zo belangrijk; ze dragen de toekomst van de hemel in zich!"
                }
            },
            {
                items: "eggFlying",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Hey, tu as trouvé un œuf de Gooblie volant ! Tu es vraiment doué pour les retrouver ! Prends soin de lui, il est très précieux.",
                    en: "Hey, you found a flying Gooblie egg! You’re really good at finding them! Take good care of it, it’s very precious.",
                    de: "Hey, du hast ein fliegendes Gooblie-Ei gefunden! Du bist wirklich gut darin, sie zu finden! Pass gut darauf auf, es ist sehr wertvoll.",
                    nl: "Hé, je hebt een vliegend Gooblie-ei gevonden! Je bent echt goed in het vinden ervan! Zorg goed voor het ei, het is erg kostbaar."
                },
                unblockItem: true,
                icon: <FaEgg style={{ width:"32", height:"32"}}/>
            },
            {
                items:  "none",
                position: null,
                soundBefore: "whoosh01",
                messageBefore: null,
                messageAfter: {
                    fr: "Tu as entendu ce bruit ? C'est le vent mystérieux qui transporte les œufs de Gooblies volants. Il faut vite les retrouver avant qu'ils ne soient emportés trop loin !",
                    en: "Did you hear that sound? It’s the mysterious wind carrying the flying Gooblie eggs. We must find them quickly before they are carried too far away!",
                    de: "Hast du dieses Geräusch gehört? Es ist der mysteriöse Wind, der die fliegenden Gooblie-Eier trägt. Wir müssen sie schnell finden, bevor sie zu weit weggetragen werden!",
                    nl: "Heb je dat geluid gehoord? Het is de mysterieuze wind die de vliegende Gooblie-eieren draagt. We moeten ze snel vinden voordat ze te ver weg worden geblazen!"
               }
            },
            {
                items: "eggFlying",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Super, tu as trouvé un autre œuf de Gooblie volant ! Tu es vraiment un héros ! N'oublie pas, ces œufs sont très fragiles, il faut en prendre grand soin.",
                    en: "Great, you found another flying Gooblie egg! You’re truly a hero! Remember, these eggs are very fragile, so handle them with great care.",
                    de: "Super, du hast ein weiteres fliegendes Gooblie-Ei gefunden! Du bist wirklich ein Held! Denk daran, diese Eier sind sehr zerbrechlich, also sei besonders vorsichtig.",
                    nl: "Geweldig, je hebt nog een vliegend Gooblie-ei gevonden! Je bent echt een held! Vergeet niet, deze eieren zijn erg kwetsbaar, dus zorg er goed voor."
                },
                unblockItem: true,
                icon: <FaEgg style={{ width:"32", height:"32"}}/>
            },
            {
                items:  "none",
                position: null,
                soundBefore: "grass01",
                messageBefore: null,
                messageAfter: {
                    fr: "Oh, tu as entendu ce bruit ? Un Gooblies est sûrement caché dans les buissons. Si tu es attentif, tu pourras peut-être le voir.",
                    en: "Oh, did you hear that noise? A Gooblie is probably hiding in the bushes. If you stay alert, you might be able to spot it.",
                    de: "Oh, hast du das Geräusch gehört? Ein Gooblie versteckt sich bestimmt im Gebüsch. Wenn du aufmerksam bleibst, könntest du es vielleicht sehen.",
                    nl: "Oh, heb je dat geluid gehoord? Er zit waarschijnlijk een Gooblie verstopt in de struiken. Als je goed oplet, kun je hem misschien zien."
               }
            },
            {
                items: "eggFlying",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Cool, tu as trouvé un autre œuf de Gooblie volant ! Je savais que tu étais fait pour cette mission !",
                    en: "Cool, you found another flying Gooblie egg! I knew you were made for this mission!",
                    de: "Cool, du hast ein weiteres fliegendes Gooblie-Ei gefunden! Ich wusste, dass du für diese Mission gemacht bist!",
                    nl: "Geweldig, je hebt nog een vliegend Gooblie-ei gevonden! Ik wist dat je voor deze missie gemaakt was!"
                },
                unblockItem: true,
                icon: <FaEgg style={{ width:"32", height:"32"}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Savais-tu que les ailes des Gooblies volants sont faites de soie lunaire et de gouttelettes de rosée étoilée ? Cette combinaison rare leur donne un éclat chatoyant et une légèreté incroyable, leur permettant de virevolter dans le ciel comme des esprits libres, portant la magie du crépuscule avec eux.",
                    en: "Did you know that the wings of flying Gooblies are made of moon silk and drops of stardust dew? This rare combination gives them a shimmering glow and incredible lightness, allowing them to soar through the sky like free spirits, carrying the magic of twilight.",
                    de: "Wusstest du, dass die Flügel der fliegenden Gooblies aus Mondseide und Tropfen von Sternenstaubtau bestehen? Diese seltene Kombination verleiht ihnen ein schimmerndes Leuchten und unglaubliche Leichtigkeit, sodass sie wie freie Geister durch den Himmel gleiten und die Magie der Dämmerung tragen.",
                    nl: "Wist je dat de vleugels van de vliegende Gooblies gemaakt zijn van maanzijde en dauwdruppels van sterrenstof? Deze zeldzame combinatie geeft ze een schitterende gloed en ongelooflijke lichtheid, waardoor ze door de lucht kunnen zweven als vrije geesten, de magie van de schemering met zich meedragend."
               }
            },
            {
                items: "eggFlying",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Hey ! Tu as trouvé un autre œuf de Gooblie volant ! Tu vas rétablir l'équilibre des cieux !",
                    en: "Hey! You found another flying Gooblie egg! You're restoring the balance of the skies!",
                    de: "Hey! Du hast ein weiteres fliegendes Gooblie-Ei gefunden! Du stellst das Gleichgewicht des Himmels wieder her!",
                    nl: "Hé! Je hebt nog een vliegend Gooblie-ei gevonden! Je herstelt de balans van de hemel!"
                },
                unblockItem: true,
                icon: <FaEgg style={{width:"32", height:"32"}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Retrouver les œufs de Gooblies volants est crucial pour préserver la magie du royaume. Chaque œuf cache un futur gardien des vents enchantés et de la lumière céleste, essentiels à l'équilibre du monde des Gooblies.",
                    en: "Finding the flying Gooblie eggs is crucial to preserving the kingdom's magic. Each egg holds a future guardian of the enchanted winds and celestial light, essential for maintaining balance in the Gooblie world.",
                    de: "Das Auffinden der fliegenden Gooblie-Eier ist entscheidend, um die Magie des Königreichs zu bewahren. Jedes Ei birgt einen zukünftigen Wächter der verzauberten Winde und des himmlischen Lichts, die für das Gleichgewicht der Gooblie-Welt unerlässlich sind.",
                    nl: "Het vinden van de vliegende Gooblie-eieren is cruciaal om de magie van het koninkrijk te behouden. Elk ei bevat een toekomstige beschermer van de betoverde winden en het hemelse licht, die essentieel zijn voor het evenwicht in de wereld van de Gooblies."
                }
            },
        ],
        name:{
            fr: "La Quête des cieux",
            nl: "De Queeste van de Hemel",
            en: "The Quest of the Skies",
            de: "Die Himmels-Quest"
        },
        artifact:{
            id: "284b860a-89fb-4ab6-a2ac-425c2d1ff476",
            name: "Flying",
            url: "/images/artifact_flying.jpeg"
        },
        messageUnblocked: {
            fr: "Félicitations, tu as retrouvé tous les œufs de Gooblies volants ! Grâce à toi, ils peuvent éclore en sécurité.",
            en: "Congratulations, you've found all the flying Gooblie eggs! Thanks to you, they can now hatch safely.",
            de: "Herzlichen Glückwunsch, du hast alle fliegenden Gooblie-Eier gefunden! Dank dir können sie jetzt sicher schlüpfen.",
            nl: "Gefeliciteerd, je hebt alle vliegende Gooblie-eieren gevonden! Dankzij jou kunnen ze veilig uitkomen."
        },
        background: "#da1010",
        color:"white",
        icon: <FaFeather style={{marginLeft:2}}/>,
        price: 250,
        shortTitle: {
            fr: "Retrouve les oeufs de Gooblies",
            en: "Find the Gooblie eggs",
            de: "Finde die Gooblie-Eier",
            nl: "Vind de Gooblie-eieren"
        }
    },
    {
        id: "aae6f4f9-2821-494d-880e-86e01c67701d",
        type : "RANDOM",
        element : [
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Tu savais que la Soupe de Bave Gluante aux Éclats Croquants est le plat préféré des Gooblies ? Ils en raffolent, et c'est pour ça qu'ils ont besoin de ton aide pour la préparer. Mais attention, les ingrédients sont très rares. Seuls les plus courageux pourront les retrouver !",
                    en: "Did you know that Slime Soup with Crunchy Shards is the Gooblies' favorite dish? They love it, and that's why they need your help to prepare it. But beware, the ingredients are very rare. Only the bravest can find them!",
                    de: "Wusstest du, dass Schleimsuppe mit knusprigen Splittern das Lieblingsgericht der Gooblies ist? Sie lieben es, und deshalb brauchen sie deine Hilfe, um es zuzubereiten. Aber Vorsicht, die Zutaten sind sehr selten. Nur die Mutigsten können sie finden!",
                    nl: "Wist je dat Slijmsoep met Knapperige Scherven het favoriete gerecht van de Gooblies is? Ze zijn er dol op, en daarom hebben ze jouw hulp nodig om het te maken. Maar pas op, de ingrediënten zijn erg zeldzaam. Alleen de dappersten kunnen ze vinden!"
                 }
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Champignons Fétides à Pois Verts",
                        en: "Fetid Green-Spotted Mushrooms",
                        de: "Übelriechende Pilze mit Grünen Punkten",
                        nl: "Stinkende Groene Stippen Paddenstoelen"
                   },
                    url: "/images/ingredients01.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Félicitations, tu as trouvé les Champignons Fétides à Pois Verts !",
                    en: "Congratulations, you've found the Fetid Green-Spotted Mushrooms!",
                    de: "Herzlichen Glückwunsch, du hast die übelriechenden Pilze mit grünen Punkten gefunden!",
                    nl: "Gefeliciteerd, je hebt de stinkende groene stippen paddenstoelen gevonden!"
                },
                unblockItem: true,
                icon: <FaCarrot style={{width:'32', height:'32'}}/>
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "La Gelée de Moustiques Dorés",
                        en: "Golden Mosquito Jelly",
                        de: "Goldene Mücken-Gelee",
                        nl: "Gouden Muggengelei"
                    },
                    url: "/images/ingredients02.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Hey ! Tu as trouvé la Gelée de Moustiques Dorés !",
                    en: "Hey! You've found the Golden Mosquito Jelly!",
                    de: "Hey! Du hast das goldene Mücken-Gelee gefunden!",
                    nl: "Hé! Je hebt de gouden muggengelei gevonden!"
                },
                unblockItem: true,
                icon: <FaCarrot style={{width:'32', height:'32'}}/>
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Des Pétales de Fleur de Fromage Moisi",
                        en: "Petals of Moldy Cheese Flower",
                        de: "Blütenblätter der Schimmelkäseblume",
                        nl: "Bloemblaadjes van de Schimmelkaasbloem"
                   },
                    url: "/images/ingredients03.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Trop fort, tu as trouvé des Pétales de Fleur de Fromage Moisi !",
                    en: "Awesome, you've found the Petals of Moldy Cheese Flower!",
                    de: "Klasse, du hast die Blütenblätter der Schimmelkäseblume gefunden!",
                    nl: "Geweldig, je hebt de bloemblaadjes van de schimmelkaasbloem gevonden!"
                },
                unblockItem: true,
                icon: <FaCarrot style={{width:'32', height:'32'}}/>
            }
        ],
        name:{
            fr: "La Quête de la Soupe de Bave Gluante aux Éclats Croquants",
            en: "The Quest for Slime Soup with Crunchy Shards",
            de: "Die Quest der Schleimsuppe mit Knusprigen Splittern",
            nl: "De Queeste naar Slijmsoep met Knapperige Scherven"
        },
        artifact:{
            id: "dd46a4e9-5a23-43a5-91ee-8f571521e2af",
            name: "Cooking",
            url: "/images/artifact_cooking.jpeg"
        },
        messageUnblocked: {
            fr: "Bravo, tu as retrouvé tous les ingrédients pour la Soupe de Bave Gluante aux Éclats Croquants ! Hubert va pouvoir faire sa soupe et les Gooblies vont se régaler !",
            en: "Congratulations, you've found all the ingredients for the Slime Soup with Crunchy Shards! Hubert can now make the soup, and the Gooblies will feast!",
            de: "Herzlichen Glückwunsch, du hast alle Zutaten für die Schleimsuppe mit knusprigen Splittern gefunden! Hubert kann jetzt die Suppe machen und die Gooblies werden schlemmen!",
            nl: "Gefeliciteerd, je hebt alle ingrediënten voor de Slijmsoep met Knapperige Scherven gevonden! Hubert kan nu de soep maken en de Gooblies gaan smullen!"
       },
        background: "#da1010",
        color:"white",
        price: 250,
        private: true,
        shortTitle: {
            fr: "Retrouve les ingrédients",
            en: "Find the ingredients",
            de: "Finde die Zutaten",
            nl: "Vind de ingrediënten"
        }
    },
    {
        id: "61945bfa-700e-4c33-9f64-38408f201fd6",
        type: "RANDOM",
        element: [
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Oh non ! Le Père Noël a perdu plusieurs de ses sacs de jouets lors de sa tournée magique. Sans eux, il ne pourra pas terminer la distribution des cadeaux. C'est à toi, jeune aventurier, de les retrouver avant qu'il ne soit trop tard ! Mais attention, la neige recouvre tout et certains sacs sont bien cachés. Pars vite à leur recherche et sauve Noël !",
                    en: "Oh no! Santa has lost several of his toy sacks during his magical journey. Without them, he can't finish delivering presents. It's up to you, brave adventurer, to find them before it's too late! But beware, the snow covers everything and some sacks are well hidden. Hurry up and save Christmas!",
                    de: "Oh nein! Der Weihnachtsmann hat während seiner magischen Reise mehrere Geschenksäcke verloren. Ohne sie kann er die Geschenke nicht ausliefern. Es liegt an dir, mutiger Abenteurer, sie zu finden, bevor es zu spät ist! Aber Vorsicht, der Schnee bedeckt alles, und einige Säcke sind gut versteckt. Beeile dich und rette Weihnachten!",
                    nl: "Oh nee! De Kerstman heeft tijdens zijn magische reis meerdere zakken met speelgoed verloren. Zonder deze zakken kan hij de cadeautjes niet bezorgen. Het is aan jou, dappere avonturier, om ze te vinden voordat het te laat is! Maar pas op, de sneeuw bedekt alles en sommige zakken zijn goed verborgen. Schiet op en red Kerstmis!"
                }
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Les sacs de jouets contiennent bien plus que des cadeaux... Ils sont magiques et diffusent une énergie qui rend Noël si spécial. Chaque sac retrouvé rapproche le Père Noël de sa mission de faire sourire des millions d'enfants à travers le monde. Allez, continue, les fêtes dépendent de toi !",
                    en: "The toy sacks hold more than just gifts... They carry magic that makes Christmas so special. Every sack you find brings Santa closer to his mission of making millions of children smile around the world. Keep going, the holidays depend on you!",
                    de: "Die Geschenksäcke enthalten mehr als nur Geschenke... Sie tragen Magie, die Weihnachten so besonders macht. Jeder gefundene Sack bringt den Weihnachtsmann seiner Mission näher, Millionen von Kindern auf der ganzen Welt ein Lächeln zu schenken. Mach weiter, die Feiertage hängen von dir ab!",
                    nl: "De zakken met speelgoed bevatten meer dan alleen cadeautjes... Ze dragen magie die Kerstmis zo bijzonder maakt. Elke zak die je vindt, brengt de Kerstman dichter bij zijn missie om miljoenen kinderen over de hele wereld te laten glimlachen. Ga door, de feestdagen hangen van jou af!"
                }
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Sac de jouets",
                        en: "Toy Sack",
                        de: "Geschenksack",
                        nl: "Speelgoedzak"
                    },
                    url: "/images/toysack03.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Génial, tu as trouvé un sac de jouets ! Continue comme ça, Noël a besoin de toi.",
                    en: "Great, you've found a toy sack! Keep it up, Christmas needs you.",
                    de: "Super, du hast einen Geschenksack gefunden! Mach weiter so, Weihnachten braucht dich.",
                    nl: "Geweldig, je hebt een speelgoedzak gevonden! Ga zo door, Kerstmis heeft je nodig."
                },
                unblockItem: true,
                icon: <FaGift style={{width: '32', height: '32'}}/>
            },
            {
                items: "egg",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Hey, tu as trouvé un œuf de Gooblie ! Tu es vraiment doué pour les retrouver ! Prends soin de lui, il est très précieux.",
                    en: "Hey, you found a Gooblie egg! You’re really good at finding them! Take good care of it, it’s very precious.",
                    de: "Hey, du hast ein Gooblie-Ei gefunden! Du bist wirklich gut darin, sie zu finden! Pass gut darauf auf, es ist sehr wertvoll.",
                    nl: "Hé, je hebt een Gooblie-ei gevonden! Je bent echt goed in het vinden ervan! Zorg goed voor het ei, het is erg kostbaar."
                },
                icon: <FaEgg style={{ width:"24", height:"24"}}/>
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Sac de jouets",
                        en: "Toy Sack",
                        de: "Geschenksack",
                        nl: "Speelgoedzak"
                    },
                    url: "/images/toysack01.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Génial, tu as trouvé un sac de jouets ! Continue comme ça, Noël a besoin de toi.",
                    en: "Great, you've found a toy sack! Keep it up, Christmas needs you.",
                    de: "Super, du hast einen Geschenksack gefunden! Mach weiter so, Weihnachten braucht dich.",
                    nl: "Geweldig, je hebt een speelgoedzak gevonden! Ga zo door, Kerstmis heeft je nodig."
                },
                unblockItem: true,
                icon: <FaGift style={{width: '32', height: '32'}}/>
            },
            {
                items: "none",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Tu es sur la bonne voie, mais le temps presse. Le Père Noël compte sur toi pour retrouver tous les sacs avant que le soleil ne se lève.",
                    en: "You're on the right track, but time is running out. Santa is counting on you to find all the sacks before sunrise.",
                    de: "Du bist auf dem richtigen Weg, aber die Zeit läuft davon. Der Weihnachtsmann zählt auf dich, alle Säcke vor Sonnenaufgang zu finden.",
                    nl: "Je bent op de goede weg, maar de tijd dringt. De Kerstman rekent op jou om alle zakken te vinden voor zonsopgang."
                }
            },
            {
                items: "egg",
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Génial, tu as trouvé un autre œuf de Gooblie ! Tu es vraiment un héros ! N'oublie pas, ces œufs sont très fragiles, il faut en prendre grand soin.",
                    en: "Great, you found another Gooblie egg! You're truly a hero! Remember, these eggs are very fragile, so handle them with great care.",    
                    de: "Super, du hast ein weiteres Gooblie-Ei gefunden! Du bist wirklich ein Held! Denk daran, diese Eier sind sehr zerbrechlich, also sei besonders vorsichtig.",
                    nl: "Geweldig, je hebt nog een Gooblie-ei gevonden! Je bent echt een held! Vergeet niet, deze eieren zijn erg kwetsbaar, dus zorg er goed voor."
                },
                icon: <FaEgg style={{ width:"24", height:"24"}}/>
            },
            {
                items: "none",
                details: {
                    name: {
                        fr: "Sac de jouets",
                        en: "Toy Sack",
                        de: "Geschenksack",
                        nl: "Speelgoedzak"
                    },
                    url: "/images/toysack02.jpeg"
                },
                position: null,
                soundBefore: null,
                messageBefore: null,
                messageAfter: {
                    fr: "Super travail, un autre sac sauvé ! Noël est entre de bonnes mains grâce à toi.",
                    en: "Great job, another sack saved! Christmas is in good hands thanks to you.",
                    de: "Großartige Arbeit, ein weiterer Sack gerettet! Weihnachten ist dank dir in guten Händen.",
                    nl: "Goed gedaan, weer een zak gered! Kerstmis is in goede handen dankzij jou."
                },
                unblockItem: true,
                icon: <FaGift style={{width: '32', height: '32'}}/>
            }
        ],
        name: {
            fr: "La Quête de Noël",
            en: "The Christmas Quest",
            de: "Die Weihnachts-Quest",
            nl: "De Kerst-queeste"
        },
        artifact: {
            id: "61945bfa-700e-4c33-9f64-38408f201fd6",
            name: "Étoile de Noël",
            url: "/images/artifact_christmas.jpeg"
        },
        messageUnblocked: {
            fr: "Félicitations, tu as retrouvé tous les sacs de jouets ! Grâce à toi, Noël est sauvé !",
            en: "Congratulations, you've found all the toy sacks! Thanks to you, Christmas is saved!",
            de: "Herzlichen Glückwunsch, du hast alle Geschenksäcke gefunden! Dank dir ist Weihnachten gerettet!",
            nl: "Gefeliciteerd, je hebt alle speelgoedzakken gevonden! Dankzij jou is Kerstmis gered!"
        },
        background: "#138511!important",
        color: "white",
        icon: <FaTree style={{marginLeft: 2}}/>,
        price: 250,
        shortTitle:{
            fr: "Retrouve les sacs de jouets",
            en: "Find all the toy sacks",
            de: "Finde alle Geschenksäcke",
            nl: "Vind alle speelgoedzakken"
        }
    }
    
]
